'use client'

import { Container, Row, Col } from "react-bootstrap";
import { useTranslations } from 'next-intl'
import { useRouter } from 'i18n/navigation';

export default function CompanyShortDesc() {
  const router=useRouter();
  const t = useTranslations('home');
  const t1 = useTranslations('meta');
  
  return (
    <div
      style={{
        backgroundColor: "#EFF3E6 ",
      }}
      className="py-5"
    >
      <Container>
        <Row style={{ paddingBottom: "1rem" }}>
          <Col>
            <h1>
              {t1('meta_dig_sov')}<br></br>{t("company_short_heading")} 
            </h1>
          </Col>
        </Row>
        <Row style={{ paddingBottom: "1rem" }}>
          <Col>
            {t("company_short_descr" )} 
          </Col>
        </Row>
        <Row style={{ paddingBottom: "1rem" }}>
          <Col>
            <h3>
              {t("oss_facts" )} 
            </h3>
          </Col>
        </Row>
        <Row style={{ paddingBottom: "2rem" }}>
          <Col>
            <ol>
              <li>
                {t("oss_fact_1" )} 
                <ul>
                  <li>
                    {t("oss_fact_1_1" )} 
                  </li>
                  <li>
                    {t("oss_fact_1_2" )} 
                  </li>
                  <li>
                    {t("oss_fact_1_3" )} 
                  </li>
                </ul>
              </li>
              <li>
                {t("oss_fact_2" )} 
                <ul>
                  <li>
                    {t("oss_fact_2_1")} 
                  </li>
                  <li>
                    {t("oss_fact_2_2" )}
                  </li>
                  <li>
                    {t("oss_fact_2_3" )}
                  </li>
                </ul>
              </li>
              <li>
                {t("oss_fact_3" )}
                <ul>
                  <li>
                    {t("oss_fact_3_1" )}
                  </li>
                  <li>
                    {t("oss_fact_3_2" )}
                  </li>
                  <li>
                    {t("oss_fact_3_3" )}
                  </li>
                </ul>
              </li>
              <li>
                {t("oss_fact_4" )}
                <ul>
                  <li>
                    {t("oss_fact_4_1" )}
                  </li>
                  <li>
                    {t("oss_fact_4_2" )}
                  </li>
                  <li>
                    {t("oss_fact_4_3" )}
                  </li>
                </ul>
              </li>
              <li>
                {t("oss_fact_5" )}
                <ul>
                  <li>
                    {t("oss_fact_5_1" )}
                  </li>
                  <li>
                    {t("oss_fact_5_2" )}
                  </li>
                  <li>
                    {t("oss_fact_5_3" )}
                  </li>
                </ul>
              </li>
              <li>
                {t("oss_fact_6" )}
                <ul>
                  <li>
                    {t("oss_fact_6_1" )}
                  </li>
                  <li>
                    {t("oss_fact_6_2" )}
                  </li>
                  <li>
                    {t("oss_fact_6_3" )}
                  </li>
                </ul>
              </li>
            </ol>
          </Col>
        </Row>
        <Row>
          <Col>
            <button
              type="button"
              className="btn btn-outline-dark"
              onClick={() => router.push("/services")}
            >
              {t("about_us" )}
            </button>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
